export const imageLoader = ({
  src,
  width = 0,
}: {
  src: string
  width: number
}): string => {
  return `${src}?w=${width}`
}
